import { render, staticRenderFns } from "./Doctor.vue?vue&type=template&id=cd340dd4&scoped=true&"
import script from "./Doctor.vue?vue&type=script&lang=js&"
export * from "./Doctor.vue?vue&type=script&lang=js&"
import style1 from "./Doctor.vue?vue&type=style&index=1&id=cd340dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd340dd4",
  null
  
)

export default component.exports